module.exports = __webpack_public_path__ + "img/Golden_Bricks.5a803a4c.svg";